var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 154,
    viewBox: "0 0 50 154",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.1925 93.1367C49.1925 80.645 24.593 35.6699 24.593 35.6699C24.593 35.6699 0 80.645 0 93.1367C0 105.628 11.0119 115.759 24.593 115.759C38.1742 115.759 49.1925 105.616 49.1925 93.1367Z",
    fill: "#F4B39E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.125 147.307C31.125 148.587 28.006 149.515 24.2033 149.438C20.4006 149.362 17.3457 148.293 17.3713 147.039",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.125 147.307C31.125 148.587 28.006 149.515 24.2033 149.438C20.4006 149.362 17.3457 148.293 17.3713 147.039",
    stroke: "#0C0E1F",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3166 93.854L17.3516 147.04C17.3516 148.319 20.3363 151.929 24.139 151.999C27.9417 152.07 31.0861 148.556 31.1053 147.308L31.802 94.1932",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3166 93.854L17.3516 147.04C17.3516 148.319 20.3363 151.929 24.139 151.999C27.9417 152.07 31.0861 148.556 31.1053 147.308L31.802 94.1932",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7895 94.2307C31.7895 93.2068 28.8175 92.3109 25.1107 92.2469C21.4038 92.1829 18.3873 92.9508 18.3682 93.9747",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7895 94.2307C31.7895 93.2068 28.8175 92.3109 25.1107 92.2469C21.4038 92.1829 18.3873 92.9508 18.3682 93.9747",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2539 106.658C22.9377 106.735 23.6599 106.78 24.414 106.793C28.4528 106.869 31.7439 106.031 31.7694 104.917",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2539 101.226C22.9377 101.296 23.6599 101.341 24.414 101.354C28.4528 101.43 31.7439 100.592 31.7694 99.4785",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2539 95.7861C22.9377 95.8565 23.6599 95.9013 24.414 95.9141C28.4528 95.9909 31.7439 95.1526 31.7694 94.0391",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2237 10.5904C30.2237 12.1519 27.9358 13.3742 25.1748 13.323C22.4139 13.2718 20.2089 11.9599 20.2345 10.3985L19.3652 4.71576C19.3652 3.1543 22.0944 1.93842 25.3922 2.00241C28.69 2.06641 31.3423 3.38469 31.3103 4.94615L30.2237 10.5904Z",
    fill: "#F4B39E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5195 7.49952C24.1027 7.59664 24.6923 7.65012 25.2834 7.6595C28.5812 7.72349 31.2784 6.50761 31.3103 4.94615C31.3423 3.38469 28.69 2.06641 25.3922 2.00241C22.0944 1.93842 19.3972 3.1543 19.3652 4.71576L20.2345 10.3985C20.2345 11.9599 22.4202 13.2718 25.1748 13.323C27.9294 13.3742 30.1918 12.1519 30.2237 10.5904",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1748 13.3228V59.0978",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0212 73.9895C31.7631 73.9895 25.0212 58.1445 25.0212 58.1445C25.0212 58.1445 17.8127 73.9895 25.0212 73.9895Z",
    fill: "white",
    stroke: "#1C1E2C",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.7598 103.011C41.2396 101.954 42.4491 100.562 43.2898 98.9485C44.1305 97.3348 44.5785 95.5451 44.5973 93.7251C44.5973 91.2933 42.8272 86.5194 40.597 81.4702",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/step_3.94de0609735b0b8baf0f17d85af6a840.svg";
export { ForwardRef as ReactComponent };